import request from './http';
/**
 * 用户查询参编单位
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateCBDW = function (code, qiyename, socialcreditcode) {
  return request.get(`/bzw/certificateCBDW/userGetCert?code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
/**
 * 用户查询企业牌匾
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateQYPB = function (code, qiyename, socialcreditcode) {
  return request.get(`/bzw/certificateQYPB/userGetCert?code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
/**
 * 用户查询企业荣誉
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateQYRY = function (code, qiyename, socialcreditcode) {
  return request.get(`/bzw/certificateQYRY/userGetCert?code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
/**
 * 用户查询企业证书
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateQYZS = function (code, qiyename, socialcreditcode) {
  return request.get(`/bzw/certificateQYZS/userGetCert?code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
/**
 * 用户查询参编人员
 * @param {*} code 证书编号
 * @param {*} name 姓名
 * @param {*} cardid 证件号
 * @returns 
 */
export const certificateCBRY = function (code, name, cardid) {
  return request.get(`/bzw/certificateCBRY/userGetCert?code=${code}&name=${name}&cardid=${cardid}`);
}
/**
 * 用户查询主编人员
 * @param {*} code 证书编号
 * @param {*} name 姓名
 * @param {*} cardid 证件号
 * @returns 
 */
export const certificateZBRY = function (code, name, cardid) {
  return request.get(`/bzw/certificateZBRY/userGetCert?code=${code}&name=${name}&cardid=${cardid}`);
}
/**
 * 用户查询主编单位
 * @param {String} code 证书编号
 * @param {String} qiyename 企业名称
 * @param {String} socialcreditcode 信用代码
 * @returns 
 */
export const certificateZBDW = function (code, qiyename, socialcreditcode) {
  return request.get(`/bzw/certificateZBDW/userGetCert?code=${code}&qiyename=${qiyename}&socialcreditcode=${socialcreditcode}`);
}
